"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var HairDryer = function HairDryer() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    // eslint-disable-next-line max-len
    d: "M5.5 7.99997C6.60457 7.99997 7.5 7.10454 7.5 5.99997C7.5 4.8954 6.60457 3.99997 5.5 3.99997C4.39543 3.99997 3.5 4.8954 3.5 5.99997C3.5 7.10454 4.39543 7.99997 5.5 7.99997Z",
    fill: "#75767A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd" // eslint-disable-next-line max-len
    ,

    d: "M0.5 5.99997C0.5 2.84096 3.30955 0.421405 6.43362 0.890014L17.5 2.54997V9.44997L11.0447 10.4183C10.4526 10.5071 10.0708 11.0927 10.2283 11.6703L11.6818 17H14.5C15.0523 17 15.5 16.5523 15.5 16V15C15.5 13.3431 16.8431 12 18.5 12H19.5C20.0523 12 20.5 12.4477 20.5 13C20.5 13.5523 20.0523 14 19.5 14H18.5C17.9477 14 17.5 14.4477 17.5 15V16C17.5 17.6568 16.1569 19 14.5 19H11.6138C11.2723 19.5895 10.636 20 9.8815 20H9.02759C8.12569 20 7.33537 19.3963 7.09806 18.5262L5.26111 11.7907C5.15331 11.3954 4.81254 11.1149 4.41505 11.0156C2.1946 10.4607 0.5 8.45337 0.5 5.99997ZM8.5 5.99997C8.5 7.65569 7.1587 8.99812 5.50342 8.99997H5.49658C3.8413 8.99812 2.5 7.65569 2.5 5.99997C2.5 4.34312 3.84315 2.99997 5.5 2.99997C7.15685 2.99997 8.5 4.34312 8.5 5.99997Z",
    fill: "#75767A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    // eslint-disable-next-line max-len
    d: "M18.5 9.29997L19.6483 9.12772C20.1379 9.05429 20.5 8.63378 20.5 8.13878V3.86116C20.5 3.36616 20.1379 2.94565 19.6483 2.87222L18.5 2.69997V9.29997Z",
    fill: "#75767A"
  }));
};
var _default = HairDryer;
exports.default = _default;